// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"36070f71","30":"4e73c2a5","256":"6433d20a","270":"55448d38","466":"af22bff4","654":"38786bfb","655":"3abf8539","689":"38693ab6","787":"7da95b79"}[chunkId] + ".chunk.js";
};